const ImgData = [
  {
    id: 1,
    url: 'https://github.com/ghezel1995/mern-shop',
    title: 'MERN-Shop E-Commerce',
    imgUrl: require('../asset/mern-overview.png'),
    type: 'MERNStack, ReactRedux, ReactJS',
  },
  {
    id: 2,
    url: 'https://github.com/ghezel1995/video-conference-app',
    title: 'Video Conference App',
    imgUrl: require('../asset/video-call-review.png'),
    type: 'NodeJS',
  },
  {
    id: 3,
    url: 'https://github.com/ghezel1995/game-hub',
    title: 'GAME HUB',
    imgUrl: require('../asset/gamehub.png'),
    type: 'ReactJS',
  },
  {
    id: 4,
    url: 'https://github.com/ghezel1995/find-job',
    title: 'Find Job Vue project',
    imgUrl: require('../asset/find-job.png'),
    type: 'VueJS',
  },
  {
    id: 5,
    url: 'https://github.com/ghezel1995/ecommerce',
    title: 'E-Commerce',
    imgUrl: require('../asset/mshop.png'),
    type: 'ReactJS',
  },
  {
    id: 6,
    url: 'https://github.com/ghezel1995/admin-dashboard',
    title: 'Admin Dashboard with NextJS',
    imgUrl: require('../asset/admin.png'),
    type: 'NextJS',
  },
  {
    id: 7,
    url: 'https://github.com/ghezel1995/reactweatherfinalproject',
    title: 'Online Weather App with React',
    imgUrl: require('../asset/weather-react.png'),
    type: 'ReactJS',
  },
  {
    id: 8,
    url: 'https://github.com/ghezel1995/ghezel1995.github.io',
    title: 'My Personal Portfolio GitHub',
    imgUrl: require('../asset/personal.png'),
    type: 'ReactJS',
  },
  {
    id: 9,
    url: 'https://github.com/ghezel1995/frontend-bootcamp-site',
    title: 'How to be Creative',
    imgUrl: require('../asset/02.PNG'),
    type: 'Bootstrap',
  },

  {
    id: 10,
    url: 'https://github.com/ghezel1995/todolist',
    title: 'To-Do List - on GitHub',
    imgUrl: require('../asset/todolist.png'),
    type: 'ReactRedux, ReactJS',
  },

  {
    id: 11,
    url: 'https://github.com/ghezel1995/NewsletterForm',
    title: 'Newsletter Signup Form',
    imgUrl: require('../asset/newsletter.png'),
    type: 'JavaScript',
  },
  {
    id: 12,
    url: 'https://github.com/ghezel1995/weather',
    title: 'Online Weather App - vanillaJS',
    imgUrl: require('../asset/vanillaweather.png'),
    type: 'JavaScript',
  },
  {
    id: 13,
    url: 'https://github.com/ghezel1995/week-four-portfolio',
    title: 'Portfolio - Bootstrap',
    imgUrl: require('../asset/bootstrapPortfolio.png'),
    type: 'Bootstrap',
  },
];
export default ImgData;
